var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef, useState } from 'react';
import { maxWaitAnimationTime } from '../variables';
import useMethods from './useMethods';
var initialRect = {
    T: 0,
    L: 0,
    W: 0,
    H: 0,
    // 图像填充方式
    FIT: undefined,
};
export default function useAnimationOrigin(visible, originRef, loaded, speed, updateEasing) {
    var _a = __read(useState(initialRect), 2), originRect = _a[0], updateOriginRect = _a[1];
    // 动画状态
    var _b = __read(useState(0), 2), easingMode = _b[0], updateEasingMode = _b[1];
    var initialTime = useRef();
    var fn = useMethods({
        OK: function () { return visible && updateEasingMode(4); },
    });
    useEffect(function () {
        // 记录初始打开的时间
        if (!initialTime.current) {
            initialTime.current = Date.now();
        }
        if (!loaded) {
            return;
        }
        handleUpdateOrigin(originRef, updateOriginRect);
        // 打开动画处理
        if (visible) {
            // 小于最大允许动画时间，则执行缩放动画
            if (Date.now() - initialTime.current < maxWaitAnimationTime) {
                updateEasingMode(1);
                // 延时执行动画，保持 transition 生效
                requestAnimationFrame(function () {
                    updateEasingMode(2);
                    requestAnimationFrame(function () { return handleToShape(3); });
                });
                setTimeout(fn.OK, speed);
                return;
            }
            // 超出则不执行
            updateEasingMode(4);
            return;
        }
        // 关闭动画处理
        handleToShape(5);
    }, [visible, loaded]);
    function handleToShape(currentShape) {
        updateEasing(false);
        updateEasingMode(currentShape);
    }
    return [easingMode, originRect];
}
/**
 * 更新缩略图位置信息
 */
function handleUpdateOrigin(originRef, updateOriginRect) {
    var element = originRef && originRef.current;
    if (element && element.nodeType === 1) {
        // 获取触发时节点位置
        var _a = element.getBoundingClientRect(), top_1 = _a.top, left = _a.left, width = _a.width, height = _a.height;
        var isImage = element.tagName === 'IMG';
        updateOriginRect({
            T: top_1,
            L: left,
            W: width,
            H: height,
            FIT: isImage ? getComputedStyle(element).objectFit : undefined,
        });
    }
}
